<script>
import mapValues from 'lodash/mapValues'
import isEmpty from 'lodash/isEmpty'
export default {
  props: {
    fields: {
      type: Array,
      default: () => [
        {
          label: 'アライアンス名',
          key: 'search_name',
          name: 'searchName',
        },
        {
          label: 'メールアドレス',
          key: 'search_mail',
          name: 'searchMail',
        },
      ],
      require: true,
    },
    filterValue: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      filter: {
        page_no: 1,
      },
    }
  },
  computed: {
    colComputed() {
      if (this.fields?.length > 2) {
        return '12'
      }
      return '10'
    },
  },
  created() {
    if (!isEmpty(this.filterValue)) {
      this.fields.forEach((element) => {
        this.filter[element.key] = this.filterValue[element.key]
      })
    }
  },
  methods: {
    handleFilterSearch() {
      this.handleFilter()
    },
    handleFilter(reset = false) {
      this.$emit('filter', this.filter, reset)
    },
    handleClear() {
      this.filter = mapValues(this.filter, () => '')
      this.filter.page_no = 1
      this.handleFilter(true)
    },
  },
}
</script>

<template>
  <CCard id="base-filter-box-card" class="filter-box">
    <h6 class="font-weight-bold">フィルタ</h6>
    <validation-observer ref="observer" v-slot="{ handleSubmit }">
      <CForm @submit.stop.prevent="handleSubmit(handleFilterSearch)">
        <CRow>
          <CCol
            :xl="colComputed"
            class="d-flex align-items-start flex-wrap mb-3"
          >
            <div
              v-for="i in fields"
              :key="i.label"
              class="flex-grow-1 mr-2 align-items-start"
            >
              <BaseInput
                v-model="filter[i.key]"
                :label="i.label"
                :rules="i.rules"
                :name="i.name"
                :vee-name="i.name"
                @keyup.enter="handleFilterSearch"
              />
            </div>
            <div class="filter-box-action">
              <CButton color="primary" type="submit">
                検索
              </CButton>
              <CButton class="ml-1" color="secondary" @click="handleClear">
                クリア
              </CButton>
            </div>
          </CCol>
        </CRow>
      </CForm>
    </validation-observer>
  </CCard>
</template>

<style lang="scss" scoped>
#base-filter-box-card {
  &.filter-box {
    width: 100%;
    padding: 0.75rem 1.25rem;
    margin-bottom: 1rem;
    background-color: $feelline-bg-primary;
    border-radius: 0.25rem;
    ::v-deep label {
      margin-bottom: 0;
      font-size: 0.75rem;
      font-weight: 700;
      color: $custom-filter-box-card-label-color;
    }
    ::v-deep .form-group {
      margin-bottom: 0.5rem;
    }
    .filter-box-action {
      flex-grow: 0.5;
      align-self: flex-start;
      margin-top: 20px;
    }
  }

  h6 {
    font-size: 1rem;
    color: $custom-filter-box-card-title-color;
  }
}
</style>
